import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedSeatMapConnectingTemplate = () => {
  return {
    name: null,
    fromSeatMapTemplateId: null,
    toSeatMapTemplateId: null,
  };
};

export default {
  state: () => ({
    selectedSeatMapConnectingTemplate: getDefaultSelectedSeatMapConnectingTemplate(),
  }),

  mutations: {
    setSelectedSeatMapConnectingTemplate(state, seatMapConnectingTemplate) {
      Vue.set(state, "selectedSeatMapConnectingTemplate", seatMapConnectingTemplate);
    },
    setDefaultSelectedSeatMapConnectingTemplate(state) {
      Vue.set(state, "selectedSeatMapConnectingTemplate", getDefaultSelectedSeatMapConnectingTemplate());
    },
  },

  actions: {
    //TODO: load, update, create
    createSeatMapConnectingTemplate: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/seat-map-template-mappings/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadSeatMapConnectingTemplates: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadSeatMapConnectingTemplate: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/entity/" + request.id, {}).then((response) => {
        context.commit("setSelectedSeatMapConnectingTemplate", response.data);
        return response.data;
      });
    },

    loadPublishedSeatMapConnectingTemplates: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedSeatMapConnectingTemplateHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/seat-map-template-mappings/entity/" + seatMapConnectingTemplate.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          seatMapConnectingTemplate.intents = intents;
          seatMapConnectingTemplate.intentId = response.data.id;
          return seatMapConnectingTemplate;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/seat-map-template-mappings/draft/" + seatMapConnectingTemplate.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/publish/" + seatMapConnectingTemplate.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/reject/" + seatMapConnectingTemplate.intentId).then((response) => {
        if (seatMapConnectingTemplate.intents[0].type === "DELETE_SEAT_MAP_TEMPLATE_MAPPING") {
          seatMapConnectingTemplate.intents = null;
          seatMapConnectingTemplate.intentId = 0;
        } else if (seatMapConnectingTemplate.intents[0].type === "CREATE_SEAT_MAP_TEMPLATE_MAPPING") {
          seatMapConnectingTemplate.intents[0].status = "DRAFT";
        } else if (seatMapConnectingTemplate.intents[0].type === "UPDATE_SEAT_MAP_TEMPLATE_MAPPING") {
          seatMapConnectingTemplate.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/sendToApproval/" + seatMapConnectingTemplate.intentId)
        .then((response) => {
          if (seatMapConnectingTemplate.intents[0].type === "CREATE_SEAT_MAP_TEMPLATE_MAPPING") {
            seatMapConnectingTemplate.intents[0].status = "WAITING_APPROVAL";
          } else if (seatMapConnectingTemplate.intents[0].type === "UPDATE_SEAT_MAP_TEMPLATE_MAPPING") {
            seatMapConnectingTemplate.intents[0].status = "WAITING_APPROVAL";
          }
          return response.data;
        });
    },

    recallSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/recall/" + seatMapConnectingTemplate.intentId).then((response) => {
        helper.recallOrRejectEntity(seatMapConnectingTemplate, "seatMapConnectingTemplate");
        return response.data;
      });
    },

    cancelSeatMapConnectingTemplate: (context, seatMapConnectingTemplate) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map-template-mappings/cancel/" + seatMapConnectingTemplate.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedSeatMapConnectingTemplate: (state) => {
      return state.selectedSeatMapConnectingTemplate;
    },
  },
};
